import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { AdminHeader, Panel, TextInput, TextArea } from "@/components/admin/ui";
import { useAuth } from "@/context/AuthContext";
import { canAccess } from "@/lib/perms";

export default function SeoManager() {
  const { user } = useAuth();
  const canEdit = canAccess(user?.role, "seo");
  const [data, setData] = useState({ title: "", description: "", keywords: "", og_image: "" });

  useEffect(() => { api.get("/settings/seo").then((r) => setData({ title: "", description: "", keywords: "", og_image: "", ...r.data.data })).catch(() => {}); }, []);

  const save = async () => {
    try { await api.put("/settings/seo", { data }); toast.success("SEO settings saved"); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };

  const set = (k) => (e) => setData({ ...data, [k]: e.target.value });

  return (
    <div>
      <AdminHeader title="SEO & Meta Manager" subtitle="Global metadata used across the site. Sitemap: /api/sitemap.xml · Robots: /api/robots.txt" />
      <Panel className="p-6 max-w-2xl space-y-5">
        <TextInput label="Meta Title" value={data.title} onChange={set("title")} disabled={!canEdit} testid="seo-title" />
        <TextArea label="Meta Description" rows={3} value={data.description} onChange={set("description")} disabled={!canEdit} testid="seo-description" />
        <TextInput label="Keywords (comma separated)" value={data.keywords} onChange={set("keywords")} disabled={!canEdit} testid="seo-keywords" />
        <TextInput label="Open Graph Image URL" value={data.og_image} onChange={set("og_image")} disabled={!canEdit} testid="seo-og" />
        {data.og_image && <img src={data.og_image} alt="OG preview" className="rounded border border-[#203E70] max-h-40" />}
        {canEdit && <button onClick={save} className="btn-gold px-6 py-2.5 text-sm" data-testid="seo-save">Save SEO Settings</button>}
      </Panel>
    </div>
  );
}
